<div class="sub-menu-root-container product-menu-root-container"
    [style.width]="show ? 'var(--left-side-optionbar-width)' : '25px'">
    <div class="menu-list-container">
        <!-- Masters List -->

        <mat-list-item class="mat-list-item" *ngIf="hasAccess('uom')" routerLink="/product/uom"
            [routerLinkActive]="['is-active']" (click)="resetState()" [matTooltip]="!show ? 'UOM' : ''"
            matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/uom.svg">
                <span class="master-title" style="word-wrap: break-word;">UOM
                </span>
            </div>
        </mat-list-item>
        <!-- <mat-list-item class="mat-list-item" routerLink="/stock-category" [routerLinkActive]="['is-active']"
                    [matTooltip]="!show ? 'Employee' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
                    <div class="mat-list-item-contents">
                        <img src="assets/images/menu/svg/stock-category.svg">
                        <span class="master-title">Stock Category</span>
                    </div>
                </mat-list-item>
                <mat-list-item class="mat-list-item" routerLink="/item-category" [routerLinkActive]="['is-active']"
                    [matTooltip]="!show ? 'Payroll Group' : ''" matTooltipPosition="right"
                    matTooltipClass="mat-tooltip">
                    <div class="mat-list-item-contents">
                        <img src="assets/images/menu/svg/item-category.svg">
                        <span class="master-title"> Item Class
                        </span>
                    </div>
                </mat-list-item> -->
        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('menu')" class="mat-list-item"
            routerLink="/product/menu" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Menu' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/menu.svg">
                <span class="master-title">Menu</span>
            </div>
        </mat-list-item>

        <mat-list-item class="mat-list-item" *ngIf="hasAccess('item-class')" routerLink="/product/item-class"
            [routerLinkActive]="['is-active']" (click)="resetState()" [matTooltip]="!show ? 'Item Class' : ''"
            matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/item-category.svg">
                <span class="master-title"> Item Class
                </span>
            </div>
        </mat-list-item>

        <mat-list-item class="mat-list-item" *ngIf="hasAccess('sale-item')" routerLink="/product/sale-item"
            [routerLinkActive]="['is-active']" (click)="resetState()" [matTooltip]="!show ? 'Sale Item' : ''"
            matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/items.svg">
                <span class="master-title">Sale Item
                </span>
            </div>
        </mat-list-item>

        <mat-list-item class="mat-list-item" *ngIf="userData?.user_type === 'HQ' && hasAccess('sale-item-bulk-update')"
            routerLink="/product/sale-item-bulk-update" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Bulk Update' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/sale-item-bulk-update.svg">
                <span class="master-title">Bulk Update
                </span>
            </div>
        </mat-list-item>

        <mat-list-item class="mat-list-item" *ngIf="hasAccess('customization')" routerLink="/product/customization"
            [routerLinkActive]="['is-active']" (click)="resetState()" [matTooltip]="!show ? 'Customization' : ''"
            matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/customization.svg">
                <span class="master-title">Customization</span>
            </div>
        </mat-list-item>

        <mat-list-item class="mat-list-item" *ngIf="hasAccess('combo')" routerLink="/product/combo"
            [routerLinkActive]="['is-active']" (click)="resetState()" [matTooltip]="!show ? 'Combo' : ''"
            matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/combo.svg">
                <span class="master-title">Combo
                </span>
            </div>
        </mat-list-item>
        <div class="display-order-container" *ngIf="userData?.user_type === 'HQ' && (hasAccess('item-class-display-order') || hasAccess('sale-item-display-order') || hasAccess('hot-item-display-order'))"
            [matTooltip]="!show ? 'Display Order' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">

            <div class="mat-list-item-contents" (click)="toggleDisplayOrder()">
                <img src="assets/images/menu/svg/display-order.svg">
                <span class="display-order master-title">Display Order
                    <mat-icon class="toggle-icon" [class.rotated]="showDisplayOrder">expand_more</mat-icon>
                </span>
            </div>


        </div>

        <div *ngIf="showDisplayOrder">
            <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('item-class-display-order')"
                class="mat-list-item" routerLink="/product/item-class-display-order" [routerLinkActive]="['is-active']"
                (click)="resetState()" [matTooltip]="!show ? 'Item Class Display Order' : ''" matTooltipPosition="right"
                matTooltipClass="mat-tooltip">
                <div class="mat-list-item-contents sub-menu">
                    <img src="assets/images/menu/svg/sub-menu.svg">
                    <span class="master-title sale-item-menu">Item Class
                    </span>
                </div>
            </mat-list-item>

            <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('sale-item-display-order')"
                class="mat-list-item" routerLink="/product/sale-item-display-order" [routerLinkActive]="['is-active']"
                (click)="resetState()" [matTooltip]="!show ? 'Sale Item Display Order' : ''" matTooltipPosition="right"
                matTooltipClass="mat-tooltip">
                <div class="mat-list-item-contents sub-menu">
                    <img src="assets/images/menu/svg/sub-menu.svg">
                    <span class="master-title sale-item-menu">Sale Item
                    </span>
                </div>
            </mat-list-item>
            <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('hot-item-display-order')"
                class="mat-list-item" routerLink="/product/hot-item-display-order" [routerLinkActive]="['is-active']"
                (click)="resetState()" [matTooltip]="!show ? 'Hot Item Display Order' : ''" matTooltipPosition="right"
                matTooltipClass="mat-tooltip">
                <div class="mat-list-item-contents sub-menu">
                    <img src="assets/images/menu/svg/sub-menu.svg">
                    <span class="master-title sale-item-menu">Hot Item
                    </span>
                </div>
            </mat-list-item>
        </div>
    </div>
</div>